export const handyBreakpoint = '@media (max-width: 600px)'